export const menuList = [
  {
    index: '1',
    title: 'Dashboard',
    icon: 'ri-dashboard-2-line',
    hasNewFeature: false,
    path: '/dashboard'
  },

  {
    index: '3',
    title: 'News',
    icon: 'ri-file-list-3-line',
    permissionCode: 'news-view',
    hasNewFeature: 'news',
    path: '/news-section'
  },
  {
    index: 'announcements',
    title: 'Announcements',
    icon: 'ri-file-list-3-line',
    permissionCode: null,
    hasNewFeature: 'announcements',
    path: '/announcements',
    matchPaths: ['/announcements']
  },
  {
    index: '4',
    title: 'Projects',
    icon: 'ri-slideshow-line',
    permissionCode: 'project-list',
    hasNewFeature: false,
    path: '/projects'
  },
  {
    index: 'time-tracking',
    title: 'TimeTracking',
    icon: 'ri-time-line',
    permissionCode: 'time-tracking-list',

    path: '/time-tracking'
  },
  {
    index: '411',
    title: 'Timeline',
    icon: 'ri-bar-chart-horizontal-line',
    hasNewFeature: false,
    path: '/timeline'
  },
  {
    index: '5',
    title: 'Leave',
    icon: 'ri-calendar-check-line',
    permissionCode: 'leave-request-list',
    hasNewFeature: 'leave_management',
    path: '/leaves/list',
    matchPaths: ['/leaves']
  },
  {
    index: '6',
    title: 'Payment',
    icon: 'ri-wallet-3-line',
    permissionCode: 'payment-list',
    hasNewFeature: 'payment',
    path: '/invoices/list',
    matchPaths: ['/invoices']
  },
  {
    index: 'department-budgets',
    title: 'DepartmentBudgets',
    icon: 'ri-coins-line',
    permissionCode: 'budget-list',
    hasNewFeature: false,
    path: '/budgets/list',
    matchPaths: ['/budgets']
  },
  {
    index: 'event-management',
    title: 'EventManagement',
    icon: 'ri-calendar-event-line',
    permissionCode: ['event-list', 'event-company-list'],
    hasNewFeature: 'event_management',
    children: [
      {
        groupTitle: 'EventManagement',
        items: [
          {
            index: 'event-management-events',
            title: 'Events',
            permissionCode: 'event-list',
            path: '/events',
            matchPaths: ['/events']
          },
          {
            index: 'event-management-companies',
            title: 'EventCompanies',
            permissionCode: 'event-company-list',
            path: '/events/companies',
            matchPaths: ['/events/companies']
          }
        ]
      }
    ]
  },
  {
    index: '30',
    title: 'Assets',
    icon: 'ri-archive-line',
    permissionCode: null,
    children: [
      {
        groupTitle: 'Assets',
        items: [
          {
            index: '30-request',
            title: 'AssetsRequest',
            permissionCode: 'asset-request-list',
            path: '/asset-requests',
            matchPaths: ['/asset-requests', '/asset-request']
          },
          {
            index: '30-inventory',
            title: 'AssetsInventory',
            permissionCode: 'asset-list',
            path: '/Assets',
            matchPaths: ['/Assets', '/assets']
          },
          {
            index: '30-categories',
            title: 'AssetsCategories',
            permissionCode: 'asset-category-list',
            path: '/Assets/Categories',
            matchPaths: ['/Assets/Categories']
          }
          // {
          //   index: '30-bulk',
          //   title: 'AssetsBulkUpload',
          //   permissionCode: 'asset-item-bulk-upload',
          //   path: '/Assets/BulkUpload',
          //   matchPaths: ['/Assets/BulkUpload']
          // }
        ]
      }
    ]
  },
  {
    index: '7',
    title: 'Booking',
    icon: 'ri-reserved-line',
    permissionCode: 'booking-list',
    hasNewFeature: false,
    children: [
      {
        groupTitle: 'Booking',
        items: [
          {
            index: 'booking-rooms',
            title: 'Rooms',

            permissionCode: 'room-list',
            path: '/room-reservation'
          },
          {
            index: 'booking-cars',
            title: 'Cars',
            permissionCode: 'car-list',
            path: '/car-reservation'
          },
          {
            index: 'booking-settings',
            title: 'Settings',
            permissionCode: 'booking-setting-view',
            path: '/settings'
          }
        ]
      }
    ]
  },

  {
    index: 'reports',
    title: 'Reports',
    icon: 'ri-file-chart-line',
    permissionCode: null,
    children: [
      {
        groupTitle: 'Reports',
        items: [
          {
            index: 'reports-department',
            title: 'DepartmentReports',
            permissionCode: 'report-department-list',
            path: '/reports/department',
            matchPaths: ['/reports/department', '/reports/settings/department']
          },
          {
            index: 'reports-employee',
            title: 'EmployeeReports',
            permissionCode: 'report-employee-list',
            path: '/reports/employee',
            matchPaths: ['/reports/employee', '/reports/settings/employee']
          }
        ]
      }
    ]
  },
  {
    index: '10',
    title: 'Employees',
    icon: 'ri-shield-user-line',
    permissionCode: 'employee-list',
    hasNewFeature: false,
    path: '/employees',
    matchPaths: ['/employees']
  },
  {
    index: '11',
    title: 'Clients',
    icon: 'las la-building',
    permissionCode: 'client-list',
    hasNewFeature: false,
    path: '/clients'
  },
  {
    index: '2',
    title: 'Subscription',
    icon: 'ri-bank-card-line',
    permissionCode: 'subscription-list-request',
    hasNewFeature: false,
    path: '/subscriptions'
  },
  {
    index: '12',
    title: 'OrganizationSetup',
    icon: 'ri-building-line',
    permissionCode: null,
    hasNewFeature: false,
    children: [
      {
        groupTitle: 'OrganizationSetup',
        items: [
          {
            index: '13',
            title: 'Departments',

            permissionCode: 'department-list',
            path: '/departments'
          },
          {
            index: '14',
            title: 'Groups',
            permissionCode: 'group-list',
            path: '/groups'
          },
          {
            index: '15',
            title: 'Positions',
            permissionCode: 'position-list',
            path: '/positions'
          }
        ]
      }
    ]
  },
  {
    index: '16',
    title: 'ApprovalForms',
    icon: 'ri-file-list-3-line',
    permissionCode: 'vas-request-list',
    hasNewFeature: 'vas_approval_form',
    path: '/approvalforms'
  },
  {
    index: 'approval-workflows',
    title: 'ApprovalWorkflows',
    icon: 'ri-flow-chart',
    permissionCode: ['approval-workflow-request-list', 'approval-workflow-template-list'],
    hasNewFeature: false,
    path: '/approval-workflows',
    matchPaths: ['/approval-workflows']
  },
  {
    index: '17',
    title: 'ReservationsSettings',
    icon: 'ri-settings-2-line',
    permissionCode: null,

    children: [
      {
        groupTitle: 'Booking',
        items: [
          {
            index: '18',
            title: 'Rooms',
            permissionCode: 'room-list',
            path: '/room'
          },
          {
            index: '19',
            title: 'Cars',
            permissionCode: 'car-list',
            path: '/cars'
          },
          {
            index: '20',
            title: 'Buildings',
            permissionCode: 'building-list',
            path: '/room/building'
          },
          {
            index: '21',
            title: 'Floor',
            permissionCode: 'building-view',
            path: '/room/floor'
          },
          {
            index: '22',
            title: 'Drivers',
            permissionCode: 'driver-list',
            path: '/driver-reservation'
          }
        ]
      }
    ]
  },
  {
    index: '23',
    title: 'Analytics',
    icon: 'ri-line-chart-line',
    permissionCode: null,
    hasNewFeature: 'analytics',

    children: [
      {
        groupTitle: 'analytics',
        items: [
          {
            index: '24',
            title: 'User',
            permissionCode: 'analytics-user-list',
            path: '/analytics/user'
          },
          {
            index: '25',
            title: 'Task',
            permissionCode: 'analytics-task-list',
            path: '/analytics/task'
          },
          {
            index: '26',
            title: 'Project',
            permissionCode: 'analytics-project-list',
            path: '/analytics/project'
          },
          {
            index: 'analytics-department',
            title: 'Department',
            permissionCode: 'analytics-department-list',
            path: '/analytics/department'
          },
          {
            index: 'analytics-cars',
            title: 'CarBooking',
            permissionCode: 'analytics-car-booking-list',
            path: '/analytics/car'
          }
        ]
      }
    ]
  },
  {
    index: '40',
    title: 'Evaluation',
    icon: 'ri-clipboard-line',
    permissionCode: null,
    hasNewFeature: false,
    children: [
      {
        groupTitle: 'evaluation',
        items: [
          {
            index: '31',
            title: 'Probation',
            permissionCode: 'probation-evaluation-list',
            path: '/evaluation/probation',
            matchPaths: ['/probation-evaluation']
          },
          {
            index: '32',
            title: 'Performance',
            permissionCode: 'performance-evaluation-list',
            path: '/evaluation/performance',
            matchPaths: ['/performance-evaluation']
          }
        ]
      }
    ]
  },
  {
    index: 'candidates-list',
    title: 'Candidates',
    icon: 'ri-user-search-line',
    permissionCode: 'candidate-list',
    path: '/candidates/list'
  },
  {
    index: 'internship',
    title: 'Internship',
    icon: 'ri-book-line',
    permissionCode: 'intern-list',
    hasNewFeature: false,
    path: '/internship',
    matchPaths: ['/internship']
  },
  {
    index: '28',
    title: 'OrganizationChart',
    icon: 'ri-organization-chart',
    permissionCode: 'organization-chart-view',

    path: '/organization-chart'
  },
  {
    index: 'policy',
    title: 'Policy',
    icon: 'ri-file-text-line',
    permissionCode: 'policy-content-tab-list',

    path: '/policy'
  },
  {
    index: '29',
    title: 'RolesPermissions',
    icon: 'ri-git-repository-private-line',
    permissionCode: 'role-list',

    path: '/role-permission'
  }
];
